import config from '../config/configureEnv';

export default function publicUrlWrapper(url) {
  return `${config.bocaAPIUrl}${url}`;
}



// WEBPACK FOOTER //
// ./src/utils/publicUrlWrapper.js